import { z } from "zod";

export const upsertQuestionSchema = z.object({
  question: z.string().min(1),
  answer: z.string().min(1).max(1500),
});

export type UpsertQuestionForm = z.infer<typeof upsertQuestionSchema>;

export const defaultUpsertQuestionValues: UpsertQuestionForm = {
  question: "",
  answer: "",
};
